import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import ThemeProvider from './components/ThemeProvider.jsx';
import AppErrorBoundary from './components/AppErrorBoundary.jsx';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Apolo: #root element not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </ThemeProvider>
  </StrictMode>
);

// Sprint v9 M7 — Service Worker registration.
// Só em produção (HTTPS) e fora do Electron (que tem own update mechanism).
// SW gerencia cache-first /assets + network-first /api/* + offline shell.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  const isElectron = navigator.userAgent.toLowerCase().includes('electron');
  if (!isElectron) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .catch((err) => {
          // SW falha não pode quebrar a app — log e segue.
          console.warn('[apolo:sw] registration failed:', err?.message || err);
        });
    });
  }
}
